module.exports = __webpack_public_path__ + "static/media/gc-beach-so-so.69f4f99a.png";